// extracted by mini-css-extract-plugin
export var actions = "_16-0";
export var actionsContainer = "_16-7";
export var border = "_16-1";
export var childFullHeight = "_16-f";
export var collapse = "_16-2";
export var content = "_16-a";
export var contentChild = "_16-e";
export var fullscreen = "_16-c";
export var hasLeftRadius = "_16-k";
export var headerContainer = "_16-3";
export var headerRow = "_16-5";
export var hidePadding = "_16-b";
export var navCollapsedGap = "_16-l";
export var noScrollX = "_16-m";
export var noScrollY = "_16-n";
export var noTopPadding = "_16-i";
export var optOutTopPadding = "_16-d";
export var pageMain = "_16-j";
export var pageOuter = "_16-g";
export var pagePadding = "_16-8";
export var pageScroll = "_16-9";
export var profile = "_16-o";
export var profileContainer = "_16-p";
export var profileImage = "_16-q";
export var profileMain = "_16-r";
export var profileSubtitle = "_16-t";
export var profileTitle = "_16-s";
export var showLeftPadding = "_16-h";
export var tabsPortalSlot = "_16-6";
export var tabsWrapper = "_16-4";
export var title = "_16-u";